// Get the document's writing mode and check if it's vertical
function isVerticalWritingMode() {
  const writingMode = window.getComputedStyle(
    document.documentElement
  ).writingMode;
  return writingMode.includes("vertical");
}

// Calculate the scrollbar width
function getScrollBarSize() {
  const scrollBarXSize = window.innerHeight - document.body.clientHeight;
  const scrollBarYSize = window.innerWidth - document.body.clientWidth;
  return isVerticalWritingMode() ? scrollBarXSize : scrollBarYSize;
}

// Get the scroll position
function getScrollPosition(fixed) {
  if (fixed) {
    return isVerticalWritingMode()
      ? document.scrollingElement?.scrollLeft || 0
      : document.scrollingElement?.scrollTop || 0;
  }
  return parseInt(document.body.style.insetBlockStart || "0", 10);
}

// Apply backface fixed styles
function applyStyles(scrollPosition, apply) {
  const styles = {
    blockSize: "100dvb",
    insetInlineStart: "0",
    position: "fixed",
    insetBlockStart: isVerticalWritingMode()
      ? `${scrollPosition}px`
      : `${scrollPosition * -1}px`,
    inlineSize: "100dvi",
  };

  Object.keys(styles).forEach(function (key) {
    document.body.style[key] = apply ? styles[key] : "";
  });
}

// Restore scroll position
function restorePosition(scrollPosition) {
  const options = {
    behavior: "instant",
  };

  if (isVerticalWritingMode()) {
    options.left = scrollPosition;
  } else {
    options.top = scrollPosition * -1;
  }

  window.scrollTo(options);
}

// Fix or unfix the backface
function backfaceFixed(fixed) {
  const scrollBarWidth = getScrollBarSize();
  const scrollPosition = getScrollPosition(fixed);
  document.body.style.paddingInlineEnd = fixed ? `${scrollBarWidth}px` : "";
  applyStyles(scrollPosition, fixed);

  if (!fixed) {
    restorePosition(scrollPosition);
  }
}

export const hambergerToggle = () => {
  $(function () {
    const body = $("body");

    $("#js-hambergur-btn").on("click", function () {
      // body.toggleClass('is-nav-open');
      // $('.c-page-top-btn').removeClass('is-show');
      if (body.hasClass("is-nav-open")) {
        body.removeClass("is-nav-open");
        // body.addClass('is-nav-close'); // 動作後、閉じる動きを外す
        backfaceFixed(false)
        $(".js-g-nav").on("transitionend", function () {
          body.removeClass("is-nav-close");
        });
      } else {
        body.addClass("is-nav-open");
        backfaceFixed(true)
        // $('.c-page-top-btn').removeClass('is-show');
      }
    });
  });
};
